import { UsersMenu } from "@/components/ui/menu/UsersMenu"
import { BottomNavButton } from "@/components/ui/navigation/BottomNavButton"
import { USERS_MAIN_NAV_ITEMS, type BadgeState } from "@/lib/navigationItems"
import { useUnreadChatsCount } from '@/hooks/useUnreadChatsCount';
import { useNotificationSettingsListener } from '@/hooks/useNotificationSettingsListener';
import { isNative } from '@/lib/platform';
import { useLocation } from 'react-router-dom';

export function UsersBottomNav() {
  const { hasUnread: hasUnreadChats, count: unreadCount } = useUnreadChatsCount();
  const { needsSetup: needsNotificationSetup } = useNotificationSettingsListener();
  const location = useLocation();

  const badgeState: BadgeState = {
    hasUnreadChats,
    unreadCount,
    needsNotificationSetup,
    isNative: isNative(),
    currentPath: location.pathname,
  };

  return (
    <div className="bottom-nav-container bottom-nav flex items-center justify-around">
      {USERS_MAIN_NAV_ITEMS.map((item) => (
        <BottomNavButton
          key={item.id}
          item={item}
          badgeState={badgeState}
        />
      ))}

      {/* More (Menu) */}
      <UsersMenu 
        needsNotificationSetup={needsNotificationSetup} 
      />
    </div>
  )
}
